<template>
  <b-modal ref="tecAnalysisNaModal"
           id="tecAnalysisNaModal"
           size="lg"
           :no-close-on-esc="true"
           :hide-footer="true"
           scrollable
           centered
           modal-class="tecAnalysisNaModal"
           @hide="$emit('hide')">
    <template #modal-header>
      <div class="d-flex align-items-center col-12">
        <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
        <span v-if="pci && pci.length === 1" class="modalTitle ml-auto">
          {{$lang.PCI.ATNA.Title}}
        </span>
        <span v-else class="modalTitle ml-auto">
          {{$lang.PCI.ATNA.BatchTitle}}
        </span>
        <button class="close" @click="onHide">x</button>
      </div>
    </template>
    <div>
      <div v-if="pci && pci.length > 1" class="flex-grow-1 mb-3">
        <strong class="mr-1">Sites:</strong>
        <v-select id="works-select" v-model="pci" :getOptionLabel="param => `${param.idSite} (${param.referencia})`" :deselectFromDropdown="false" multiple disabled style="width: 100%;"></v-select>
      </div>
      <label for="selService">{{ $lang.PCI.ATNA.LabelService }}</label>
      <v-select id="selService"
                :options="form.servicoAnaliseTecID.options"
                v-model="form.servicoAnaliseTecID.value"
                :required="form.servicoAnaliseTecID.required"
                label="descricao"
                :reduce="obj => obj.id"
                :state="form.servicoAnaliseTecID.state">
      </v-select>

      <label for="txtObs" class="pt-3">{{ $lang.PCI.ATNA.LabelObservation }}</label>
      <b-textarea id="txtObs"
                  v-model="form.observacao.value"
                  :required="form.observacao.required"
                  :state="form.observacao.state">
      </b-textarea>

      <div class="d-flex justify-content-end pt-3">
        <b-button @click="onValidate" variant="third">{{ $lang.Common.Buttons.Save }}</b-button>
      </div>

      <tables v-if="pci && pci.length === 1" ref="tableGrid" class="col-mdEW-12 tabela pt-3"
            :columns="[$lang.PCI.ATNA.Datatable.Work,
                      $lang.PCI.ATNA.Datatable.Date,
                      $lang.PCI.ATNA.Datatable.User,
                      $lang.PCI.ATNA.Datatable.Service,
                      $lang.PCI.ATNA.Datatable.Observation,
                      'N/A',
                      $lang.PCI.ATNA.Datatable.Cancel]"
            :showPaging="false"
            :showTipFooter="false"
            :showHeader="false">
        <tr v-for="obj in this.objList" :key="obj.id">
          <table-column :IsCustom="true">
            <span>
              {{ obj.obra.referencia }}
            </span>
          </table-column>
          <table-column :IsCustom="true">
            <span>
              {{obj.dataAcaoFormatada}}
            </span>
          </table-column>
          <table-column :IsCustom="true">
            <span>
              {{obj.nomeContaAcao}}
            </span>
          </table-column>
          <table-column :IsCustom="true">
            <span>
              {{ form.servicoAnaliseTecID.options.filter(s => s.id === obj.servicoAnaliseTecID)[0].descricao }}
            </span>
          </table-column>
          <table-column :IsCustom="true">
            <span>
              {{obj.observacao}}
            </span>
          </table-column>
          <table-column :IsStatus="true" :status="obj.status">
          </table-column>
          <table-column :IsCustom="true">
            <i v-if="obj.status === 1" class="fas fa-ban text-danger pointer" @click="onDelete(obj)"></i>
          </table-column>
        </tr>
      </tables>
    </div>
  </b-modal>
</template>

<script>
import tecanalysisna from './tecanalysisna'
export default tecanalysisna
</script>

<style scoped>
* >>> .tecAnalysisNaModal > .modal-dialog {
  width: 50vw; max-width: 50vw;
}
#works-select >>> button.vs__deselect,
#works-select >>> div.vs__actions {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/tecanalysisna/tecanalysisna.vue